import { put, takeEvery, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { setNextFormStep } from 'actions/form';
import { FORM_ERROR } from 'final-form';
import { setUser } from 'actions/user';
import { EMPLOYER } from 'constants/index';
import { openModal } from 'actions/modal';
import { checkSignUpEmail, signUpFormSubmit } from 'api/signUp';
import { startSignUpSubmit, resolveSignUpSubmit } from './actions';

export function* signUpSubmitSaga(action: any) {
  const signUpStep = yield select(state => state.formStep);
  const { email, userRole, recaptchaToken } = action.payload;

  try {
    if (signUpStep === 1) {
      yield checkSignUpEmail(email);
      yield put(resolveSignUpSubmit());
      yield put(setNextFormStep());
    }
    if (signUpStep === 2) {
      if (recaptchaToken) {
        const { data } = yield signUpFormSubmit(userRole, action.payload);
        yield put(resolveSignUpSubmit());
        if (data.role && data.role === EMPLOYER) {
          yield put(setUser(data));
          yield put(push('/dashboard'));
          yield put(openModal({ title: 'signUpComplete', data: {} }));
        } else {
          yield put(push('/signup-complete'));
        }
      } else {
        yield put(resolveSignUpSubmit({ recaptchaToken: 'Verify that you are not a robot' }));
      }
    }
  } catch (error) {
    yield put(resolveSignUpSubmit({ [FORM_ERROR]: error.response.data.error.message }));
  }
}

export default function* registrationSagas() {
  yield takeEvery(startSignUpSubmit, signUpSubmitSaga);
}
